"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalText = exports.BoldText = exports.ColorLabel = exports.Color = exports.baseColors = exports.labels = exports.GridBox = exports.StyledTextField = exports.ClientColorTitleTypography = exports.TitleTypography = exports.RootBox = void 0;
var system_1 = require("@mui/system");
var colors_1 = require("./colors");
var TextField_1 = __importDefault(require("../TextField"));
var Typography_1 = __importDefault(require("../Typography"));
var Box_1 = __importDefault(require("../Box"));
exports.RootBox = (0, system_1.styled)(Box_1.default)({
    marginBottom: '24px',
});
exports.TitleTypography = (0, system_1.styled)(Typography_1.default)({
    marginBottom: '24px',
});
exports.ClientColorTitleTypography = (0, system_1.styled)(Typography_1.default)({
    display: 'inline',
    color: colors_1.tannerPurple['500'],
});
exports.StyledTextField = (0, system_1.styled)(TextField_1.default)({
    marginTop: '24px',
    width: '281px',
    '& .MuiFormHelperText-root': {
        marginLeft: '0px',
    },
});
exports.GridBox = (0, system_1.styled)(Box_1.default)({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 12,
    paddingTop: '24px',
});
exports.labels = [
    'Client Brand/25',
    'Client Brand/50',
    'Client Brand/100',
    'Client Brand/200',
    'Client Brand/300',
    'Client Brand/400',
    'Primary Brand Color Client Brand/500',
    'Client Brand/600',
    'Client Brand/700',
    'Client Brand/800',
    'Client Brand/900',
];
exports.baseColors = [
    colors_1.tannerWhite,
    colors_1.tannerWhite,
    colors_1.tannerWhite,
    colors_1.tannerWhite,
    colors_1.tannerWhite,
    colors_1.tannerWhite,
    colors_1.tannerBlack,
    colors_1.tannerBlack,
    colors_1.tannerBlack,
    colors_1.tannerBlack,
    colors_1.tannerBlack,
];
exports.Color = (0, system_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'color'; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 110px;\n  height: ", ";\n  background-color: ", ";\n  border-radius: 8px;\n  border: ", ";\n"], ["\n  width: 110px;\n  height: ", ";\n  background-color: ", ";\n  border-radius: 8px;\n  border: ", ";\n"])), function (props) { var _a; return props.isSemantic && !((_a = props.label) === null || _a === void 0 ? void 0 : _a.includes('500')) ? '32px' : '68px'; }, function (props) { return props.color; }, function (props) {
    return props.color === colors_1.tannerWhite ? "1px solid ".concat(colors_1.tannerGray['200']) : 'none';
});
exports.ColorLabel = (0, system_1.styled)(Typography_1.default)(function (_a) {
    var bold = _a.bold, label = _a.label;
    return ({
        marginTop: '8px',
        fontSize: (label === null || label === void 0 ? void 0 : label.includes('Primary Brand Color')) ? '10px' : '12px',
        fontWeight: bold ? 'bold' : 'normal',
    });
});
exports.BoldText = (0, system_1.styled)(Typography_1.default)({
    fontWeight: 'bold',
});
exports.NormalText = (0, system_1.styled)(Typography_1.default)({
    fontWeight: 'normal',
});
var templateObject_1;
//# sourceMappingURL=styles.js.map